import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import Handlebars from 'handlebars';

Snappy.Component.Video = class Video extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-video';
	}

	constructor(element) {
		super(element);
	}

	render() {
		this.setVideoTemplate();
	}

	setVideoTemplate() {
		const source = $('#video-template').html();

		window.videoTemplate = Handlebars.compile(source);
	}
};

Snappy.Component.VideoPromo = class VideoPromo extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-video-promo';
	}

	constructor(element) {
		super(element);
	}

	render() {
		this.setVars();
		this.setVideoData();
		this.addVideoEventListeners();
	}

	setVars() {
		this.$videoPlayIcon = this.$element.find('.featured-media__expand--video');
		this.$videoThumbnailLink = this.$element.find('.responsive-image');
		this.$videoThumbnailBlock = this.$element.find('.fa-content-promo__block-link');
		this.$videoLinkBlock = this.$element.find('.video-link__block-link');
	}

	addVideoEventListeners() {
		this.$videoThumbnailLink.on('click', this.onVideoThumbnailClick.bind(this));
		this.$videoThumbnailBlock.on('click', this.onVideoThumbnailClick.bind(this));
		this.$videoLinkBlock.on('click', this.onVideoThumbnailClick.bind(this));
		if (this.$videoPlayIcon) {
			this.$videoPlayIcon.on('click', this.onVideoThumbnailClick.bind(this));
		}
	}

	onVideoThumbnailClick(event) {
        this.$window.trigger('modal:openModal', {
			title: this.videoTitle,
			$view: this.$videoTemplate,
			$prevElement: this.$element
		});

		if (this.$body.hasClass('cfa-generic')) {
            this.$window.trigger('gtm:send', [ 'Video', 'Play', this.videoTitle]);
		}

		event.preventDefault();
	}

	formatYoutubeUrl(url) {
		return url+= '?autoplay=1';
	}

	setVideoData() {
		let videoUrl = this.formatYoutubeUrl(this.$element.data('videoUrl'));
		const videoRel = this.$element.data('videoRel');

		if ( videoRel !== "" ) {
			videoUrl += '&rel=' + videoRel;
		}

		this.videoTitle = this.$element.data('videoTitle');
		this.$videoTemplate = $(window.videoTemplate({
			videoUrl
		}));
	}
};




// WEBPACK FOOTER //
// ./components/video/scripts/video.js